import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../checkListCss/checkList.css";
import { Ripple } from "primereact/ripple";
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { Nullable } from "primereact/ts-helpers";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";

import DocumentViewModal from "../../../../../Components/DocumentViewModal";
import NoDataCreated from "../../../../../Components/NoDataCreated";
import TextInput from "../../../../../Components/TextInput";
import FileInput from "../../../../../Components/FileInput";
import DatePicker from "../../../../../Components/DatePicker";
import ErrorPage from "../../../../../Components/ErrorPage";
import PageLoader from "../../../../../Components/PageLoader";
import { formatDate, parseStringToDate } from "../../../../../Utils/getDate";
import { goToTop } from "../../../../../Components/goToTop";

import { checkFileOthers, checkText } from "../../../../../Utils/Validator";

import { useSelector } from "react-redux";
import { RootState } from "../../../../../Controllers/Store";
import { hasPermission } from "../../../../../Controllers/Selectors/permissionsSelector";
import TableActionLoader from "../../../../../Components/TableActionLoader";
import { Tooltip } from "primereact/tooltip";
import { getAllCommencementChecklist } from "../../../../../Controllers/Thunks/CheckListThunks";
import { useAppDispatch, useAppSelector } from "../../../../../Controllers/hooks";
import { commencementChecklistCreateAPI, commencementChecklistDeleteAPI, commencementChecklistUpdateAPI } from "../../../../../Api/Project/DefaultServices/CheckListApi";
import { ImagePreviewModal } from "../../../../../Components/ImagePreviewModal";
import { FileShareButton } from "../../../../../Components/FileShareButton";
import { getFileNameFromUrl } from "../../../../../Utils/Common";
import { CommencementCheckListType } from "../../../../../Controllers/Types/ChecklistTypes/CommencementCheckListType";

const CommencementChecklist: React.FC = () => {
    const location = useLocation();
    const today = new Date();
    const projectData = location.state?.data;
    const serviceId = Number(projectData.folder_id);
    const isShared: boolean = projectData?.sharedBy !== null;
    const canEdit: boolean = Boolean(projectData?.can_edit);
    const dispatch = useAppDispatch();
    const [dataLoading, setDataLoading] = useState<boolean>(false);
    const [initialDataloading, setInitialDataLoading] = useState<boolean>(true);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [updateHasChanges, setUpdateHasChanges] = useState<boolean>(false);

    const [loading, setLoading] = useState<boolean>(false);
    const [statuses] = useState<string[]>(['Received', 'In Progress', 'Pending']);
    const [filterStatus] = useState<string[]>(['All', 'Received', 'In Progress', 'Pending']);

    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const [dataState, setDataState] = useState<'Add' | 'Edit'>('Add');

    const [showFileViewModal, setShowFileViewModal] = useState(false);
    const [fileUrl, setFileUrl] = useState<string | null>(null);

    const [displayData, setDisplayData] = useState<CommencementCheckListType[]>([]);
    const [showDetailModal, setShowDetailModal] = useState<boolean>(false);
    const [selectedData, setSelectedRefinancingData] = useState<CommencementCheckListType | null>(null);


    /* ****************************** Form variables **********************************/
    const [checkListTitle, setCheckListTitle] = useState<string>('');
    const [expectedDate, setExpectedDate] = useState<Nullable<Date>>(null);
    const [instructionDate, setInstructionDate] = useState<Nullable<Date>>(null);
    const [status, setStatus] = useState<string>('');
    const [file, setFile] = useState<File | null>(null);
    const [fileName, setFileName] = useState<string>('');

    /* Error message */
    const [checkListTitleError, setTitleError] = useState<string>('');
    const [expectedDateError, setExpectedDateError] = useState<string>('');
    const [instructionDateError, setInstructionDateError] = useState<string>('');

    const [statusError, setStatusError] = useState<string>('');
    const [fileError, setFileError] = useState<string>('');
    /* **************************************************************************** */

    const [deleteLoadingId, setdeleteLoadingId] = useState<number | null>(null);

    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const hasPermissionForAdd = useCanEdit('Commencement Checklist', 'add_commencement_checklist');
    const hasPermissionForEdit = useCanEdit('Commencement Checklist', 'alter_commencement_checklist');
    const hasPermissionForDelete = useCanEdit('Commencement Checklist', 'delete_commencement_checklist');

    const [showDocumentViewModalImage, setShowDocumentViewModalImage] = useState<boolean>(false);
    const [suportiveFileUrl, setSuportiveFileUrl] = useState<string>('');


    // filters
    const [selectedStatus, setSelectedStatus] = useState<string>('All');

    const checkAccessPermission = useCallback(
        (permission: boolean): boolean => {
            return isShared ? canEdit : permission;
        },
        [isShared, canEdit]
    );

    useEffect(() => {
        applicationCheckListDataGet();
    }, [serviceId]);

    /* ********************************* get data list ************************************************** */
    const applicationCheckListDataGet = async () => {
        if (serviceId) {
            setDataLoading(true);
            const data = await dispatch(getAllCommencementChecklist(Number(serviceId)));

            setDataLoading(false);
            setInitialDataLoading(false);

        }
    }

    const sateDataList = useAppSelector((state) => state.commencementDetails.commencementChecklistData);


    useEffect(() => {

        const filteredData =
            selectedStatus === 'All'
                ? sateDataList
                : sateDataList.filter((item) => item.status === selectedStatus);

        setDisplayData(filteredData);


    }, [sateDataList, selectedStatus]);


    /* ********************************* get data list ************************************************** */


    /* ***************************** For refinancing ***************************** */
    const handleCloseDetailModal = () => {
        setShowDetailModal(false);
        handleClearFormFields();
        handleClearFormErrors();
    }

    const handleClearFormFields = () => {
        setCheckListTitle('');
        setExpectedDate(null);
        setInstructionDate(null);
        setStatus('');
        setFile(null);
        setFileName('');
        setSelectedRefinancingData(null);
    }

    const handleClearFormErrors = () => {
        setTitleError('');
        setExpectedDateError('');
        setInstructionDateError('');
        setStatusError('');
        setFileError('');
    }

    const handleAddDetails = () => {
        setShowDetailModal(true);
        setDataState('Add');
    }

    useEffect(() => {
        checkText(checkListTitle, false, setTitleError);
    }, [checkListTitle]);

    useEffect(() => {
        checkText(formatDate(expectedDate || null), false, setExpectedDateError);
    }, [expectedDate]);

    useEffect(() => {
        checkText(formatDate(instructionDate || null), false, setInstructionDateError);
    }, [instructionDate]);

    useEffect(() => {
        checkText(status!, false, setStatusError);
    }, [status]);

    useEffect(() => {
        checkFileOthers(file!, false, setFileError);
    }, [file]);

    function checkCredentials(expectedDate: string, instructionDa: string): boolean {
        const isTitleValid = checkText(checkListTitle, true, setTitleError);
        const isAppliedDateValid = checkText(expectedDate, false, setExpectedDateError);
        const iseInstructionDateValid = checkText(instructionDa, false, setInstructionDateError);
        const isStatusValid = checkText(status!, true, setStatusError);
        const isFileValid = checkFileOthers(file!, false, setFileError);

        return isTitleValid && isAppliedDateValid && isStatusValid && isFileValid;
    }

    /* ******************************************* Create ******************************************* */
    const handleCreateDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        const expectedDateDateOnly = formatDate(expectedDate || null);
        const instructionDateOnly = formatDate(instructionDate || null);

        if (checkCredentials(expectedDateDateOnly, instructionDateOnly)) {
            setLoading(true);
            const data = await commencementChecklistCreateAPI(
                Number(serviceId),
                checkListTitle,
                formatDate(instructionDate!),
                formatDate(expectedDate!),
                status!,
                file!
            );

            setLoading(false);

            if (data.statusCode === 200) {
                applicationCheckListDataGet();
                handleCloseDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `${projectData.feature_name} details added successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error creating refinancing details.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* ******************************************* Create ******************************************* */


    const handleEditDetails = (refData: CommencementCheckListType) => {
        setShowDetailModal(true);
        setDataState('Edit');
        setSelectedRefinancingData(refData);

        setCheckListTitle(refData?.title);
        setExpectedDate(parseStringToDate(refData?.expected_date || ''));
        setInstructionDate(parseStringToDate(refData?.instruction_date || ''));
        setStatus(refData?.status);
    }

    /* ******************************************* Update ******************************************* */
    useEffect(() => {
        if (selectedData) {
            if (checkListTitle !== selectedData?.title) {
                setUpdateHasChanges(true);
            } else if (formatDate(expectedDate!) !== selectedData?.file_upload_date) {
                setUpdateHasChanges(true);
            } else if (status !== selectedData?.status) {
                setUpdateHasChanges(true);
            } else if (file !== null) {
                setUpdateHasChanges(true);
            }
            else {
                setUpdateHasChanges(false);
            }
        }
    }, [selectedData, checkListTitle, expectedDate, status, file])

    const handleUpdateDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        const expectedDateDateOnly = formatDate(expectedDate || null);
        const instructionDateOnly = formatDate(instructionDate || null);
        if (checkCredentials(expectedDateDateOnly, instructionDateOnly)) {

            setLoading(true);

            const data = await commencementChecklistUpdateAPI(
                Number(selectedData?.id!),
                checkListTitle,
                expectedDateDateOnly!,
                instructionDateOnly!,
                status!,
                file!
            );

            setLoading(false);

            if (data.statusCode === 200) {
                applicationCheckListDataGet();
                handleCloseDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `${projectData.feature_name} details updated successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error updating refinancing details.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* ******************************************* Update ******************************************* */


    /* ******************************************* Delete ******************************************* */
    const handleDeleteData = (refId: number): void => {
        confirmDialog({
            message: `Are you sure you want to delete this ${projectData.feature_name} data?`,
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteData(refId),
            dismissableMask: true,
            draggable: false,
            resizable: false
        });
    }

    const deleteData = async (refId: number) => {
        setdeleteLoadingId(refId);
        const data = await commencementChecklistDeleteAPI(refId);

        setdeleteLoadingId(null);
        if (data.statusCode === 200) {
            applicationCheckListDataGet();

            if (toast.current) {
                toast.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `${projectData.feature_name} data deleted successfully.`,
                    life: 3000,
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'Error deleting refinancing data.',
                    life: 3000
                });
            }
        }
    }
    /* ******************************************* Delete ******************************************* */


    const onStatusChange = (e: any) => {
        setStatus(e.value);
    };

    /* For showing statuses options in the dropdown list */
    const statusOptionTemplate = (option: string) => {
        let colorCode = '';
        if (option === 'Received') {
            colorCode = '#B9F6CA';
        } else if (option === 'In Progress') {
            colorCode = '#FFEFBC';
        } else if (option === 'Pending') {
            colorCode = '#EF9A9A';
        }
        return (
            <div className="d-flex align-items-center w-100 justify-content-between">
                <div>{option}</div>
                <div className="color_display" style={{ backgroundColor: colorCode }}></div>
            </div>
        );
    };

    const getColorCode = (status: string): string => {
        switch (status) {
            case 'All':
                return '#cb5ce7';
            case 'Received':
                return '#B9F6CA';
            case 'In Progress':
                return '#FFEFBC';
            default:
                return '#EF9A9A';
        }
    };

    /* for file upload */
    const handleFileUpload = (file: File) => {
        setFile(file);
        setFileName(file.name);
    };

    const handleClearFile = () => {
        setFile(null);
        setFileName('');
    };


    /* Modal header */
    const detailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;{projectData.feature_name} details
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseDetailModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const detailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateDetails : handleUpdateDetails}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !updateHasChanges}
            />
        </div>
    );
    /* *************************************************************************** */


    /* ***************************** For table view ****************************** */


    const getBackGroundColor = (data?: string) => {
        if (data === 'Received') {
            return 'status-cell-success';
        } else if (data === 'In Progress') {
            return 'status-cell-warning';
        } else if (data === 'Pending') {
            return 'status-cell-danger';
        }

        return 'status-cell-default';
    };


    /* *************************************************************************** */


    /* ***************************** For view file ****************************** */
    const handleViewDocument = (document: string) => {
        setFileUrl(document);
        setShowFileViewModal(true);
    }

    const handleViewImage = (document: string) => {
        setSuportiveFileUrl(document);
        setShowDocumentViewModalImage(true);
    };





    const handleCloseDocumentViewModal = () => {
        setShowFileViewModal(false);
    };
    /* *************************************************************************** */


    /* **************************** Common functions ***************************** */
    const goBack = () => {
        navigate(-1);
        goToTop();
    };
    /* *************************************************************************** */

    // table action body

    const tableActionBody = (rowData: CommencementCheckListType) => {
        const data = rowData;
        const filePath = rowData.path;
        return (
            <React.Fragment>
                <Tooltip target=".data_action_btn" />

                <div className="tabel_btn_area custom mt-1 mb-1">
                    {checkAccessPermission(hasPermissionForEdit) && (
                        <button
                            className="data_action_btn with_bg primary_table_btn p-ripple"
                            onClick={() => handleEditDetails(data)}
                            data-pr-tooltip={`Edit`}
                            data-pr-position="top"
                        >
                            <i className="bi bi-pencil-square"></i>
                            <Ripple />
                        </button>
                    )}

                    {checkAccessPermission(hasPermissionForDelete) && (
                        <button
                            className="data_action_btn with_bg danger_table_btn p-ripple"
                            onClick={() => handleDeleteData(data.id)}
                            data-pr-tooltip={`Delete`}
                            data-pr-position="top"
                        >
                            <i className="bi bi-trash3"></i>
                            <Ripple />
                        </button>
                    )}



                    <button
                        className="data_action_btn with_bg primary_table_btn p-ripple"
                        onClick={() => (rowData?.file_extension === "pdf") ? handleViewDocument(filePath ?? '') : handleViewImage(filePath ?? '')}
                        data-pr-tooltip={`View`}
                        disabled={!filePath}
                        data-pr-position="top"

                    >
                        <i className="bi bi-eye"></i>
                        <Ripple />
                    </button>

                </div>
            </React.Fragment>
        );
    };



    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {dataLoading && initialDataloading ? (
                    <PageLoader />
                ) : errorMessage ? (
                    <ErrorPage errorMessage={errorMessage} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                    {projectData.job_number} : {projectData.address}
                                </li>
                                <li className="page_breadcrumb_item has_child">
                                    {projectData.folder}
                                </li>
                                <li className="page_breadcrumb_item active">
                                    {projectData.feature_name}
                                </li>
                            </ul>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_header_area mt-sm-3 mt-3">
                          

                            <div className="status_lable_container">
                               
                                    <div className="status_lable_area">
                                        {filterStatus?.map((status, index) => {
                                            const colorCode = getColorCode(status);
                                            const isSelected = selectedStatus === status;

                                            return (
                                                <button
                                                    key={index}
                                                    type="button"
                                                    className={`status_lable ${isSelected ? 'active' : ''}`}
                                                    onClick={() => setSelectedStatus(status)}
                                                >
                                                    <span
                                                        className="status_dot"
                                                        style={{ backgroundColor: colorCode }}
                                                    ></span>

                                                    <h6>{status}</h6>
                                                </button>
                                            );
                                        })}
                                    </div>
                                
                            </div>

                            {checkAccessPermission(hasPermissionForAdd) &&
                                <div className="page_action_area">
                                    <button className="add_data_link_btn p-ripple" onClick={handleAddDetails}>
                                        <i className="bi bi-plus-circle"></i>
                                        <span>Add detail</span>
                                        <Ripple />
                                    </button>
                                </div>
                            }
                        </div>

                        <div className="page_main_content_section">
                            {displayData?.length > 0 ? (
                                <DataTable
                                    value={displayData}
                                    paginator
                                    size="small"
                                    rows={10}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    tableStyle={{ minWidth: '50rem' }}
                                    paginatorDropdownAppendTo={'self'}
                                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                    className="page_table p-0 p-sm-2"
                                    rowHover
                                    // rowClassName={getRowClassName}
                                    loading={dataLoading}
                                    scrollable
                                    dataKey="id"
                                >

                                    <Column
                                        field="status"
                                        header=""
                                        body={() => null}
                                        bodyClassName={(rowData) => `status-color-cell ${getBackGroundColor(rowData.status)}`}
                                        style={{ width: '14px', padding: '0' }}
                                    />

                                    <Column
                                        header="Title"
                                        headerClassName="text_purple"
                                        body={(rowData, { rowIndex }) => (
                                            <span className="text-capitalize">{rowIndex + 1}.&nbsp;&nbsp;&nbsp;
                                                {rowData.title ? rowData.title : '--'}
                                            </span>
                                        )}
                                        style={{ width: '40%' }}
                                    ></Column>

                                    <Column
                                        header="Assing Date"
                                        headerClassName="text_purple"
                                        alignHeader={'center'}
                                        body={(rowData) => (
                                            <span className="text_no_wrap flex_center">
                                                {rowData.instruction_date ? rowData.instruction_date : '--'}
                                            </span>
                                        )}
                                        style={{ width: '20%' }}
                                    ></Column>


                                    <Column
                                        header="Due Date"
                                        headerClassName="text_purple"
                                        alignHeader={'center'}
                                        body={(rowData) => (
                                            <span className="text_no_wrap flex_center">
                                                {rowData.expected_date ? rowData.expected_date : '--'}
                                            </span>
                                        )}
                                        style={{ width: '20%' }}
                                    ></Column>


                                    <Column
                                        alignHeader="center"
                                        body={tableActionBody}
                                        frozen
                                        alignFrozen="right"
                                    ></Column>

                                </DataTable>
                            ) : (
                                <NoDataCreated
                                    message={`No ${(projectData.feature_name).toLowerCase()} document added. ${checkAccessPermission(hasPermissionForAdd) ? 'To add the document click on add button.' : ''}`}
                                />
                            )}
                        </div>
                    </div>
                )}
            </div>


            {/* content detail modal */}
            <Dialog
                visible={showDetailModal}
                header={detailModalHeader}
                footer={detailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseDetailModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Certificate title */}
                            <div className="col-12">
                                <TextInput
                                    id="checkListTitle"
                                    label="Title"
                                    labelHtmlFor="checkListTitle"
                                    required={true}
                                    value={checkListTitle}
                                    placeholder="Title"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCheckListTitle(e.target.value)}
                                    error={checkListTitleError}
                                />
                            </div>

                            {/* instruction date */}
                            <div className="col-6">
                                <DatePicker
                                    id="instructionDate"
                                    label="Assign date"
                                    labelHtmlFor="instructionDate"
                                    required={false}
                                    value={instructionDate}
                                    minDate={today}
                                    placeholder="dd/mm/yyyy"
                                    onChange={setInstructionDate}
                                    error={instructionDateError}
                                    showClear
                                    onClear={() => setInstructionDate(null)}
                                />
                            </div>

                            {/* Due date */}
                            <div className="col-6">
                                <DatePicker
                                    id="expectedDate"
                                    label="Due date"
                                    labelHtmlFor="expectedDate"
                                    required={false}
                                    value={expectedDate}
                                    minDate={today}
                                    placeholder="dd/mm/yyyy"
                                    onChange={setExpectedDate}
                                    error={expectedDateError}
                                    showClear
                                    onClear={() => setExpectedDate(null)}
                                />
                            </div>

                            {/* Status */}
                            <div className="col-12">
                                <div className="page_form_group">
                                    <label htmlFor="status" className="custom_form_label is_required">Status</label>
                                    <Dropdown
                                        id="status"
                                        value={status}
                                        onChange={onStatusChange}
                                        options={statuses}
                                        itemTemplate={statusOptionTemplate}
                                        panelClassName="status_option_panel"
                                        placeholder="Select status"
                                        className="form_dropdown w-100"
                                        showClear
                                    />

                                    {statusError &&
                                        <small className="form_error_msg">{statusError}</small>
                                    }
                                </div>
                            </div>

                            {/* File */}
                            <div className="col-12">
                                <FileInput
                                    id="file"
                                    label="Upload file"
                                    labelHtmlFor="file"
                                    required={false}
                                    value={fileName}
                                    onUpload={handleFileUpload}
                                    onClear={handleClearFile}
                                    toast={toast}
                                    error={fileError}
                                    canUploadImage={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >


            <ImagePreviewModal
                open={showDocumentViewModalImage}
                src={suportiveFileUrl}
                alt={"image preview"}
                onClose={() => setShowDocumentViewModalImage(false)}
                title="Preview"

                toolbarRightSlot={
                    <FileShareButton
                        fileUrl={suportiveFileUrl}
                        fileName={getFileNameFromUrl(suportiveFileUrl)}
                        maxBytes={25 * 1024 * 1024}
                        onFallbackUsed={(t) => console.log("Fallback used:", t)}
                        onError={(e) => console.error(e)}
                        variant="icon"
                    />
                }
                hasDelete={false}

            />

            {/*  */}


            {/* Document view modal */}
            <DocumentViewModal
                isOpen={showFileViewModal}
                onClose={handleCloseDocumentViewModal}
                fileUrl={fileUrl!}
            />
        </React.Fragment>
    )
}

export default CommencementChecklist;